import React from 'react';
import { Scale, Award, Lock, Lightbulb, CheckCircle } from 'lucide-react';
import { badges } from '../mockData';

const iconMap = {
  Scale: Scale,
  Award: Award,
  Lock: Lock,
  Lightbulb: Lightbulb
};

const Badges = () => {
  return (
    <section className="py-8 bg-gradient-to-r from-notaria-primary via-notaria-secondary to-notaria-secondary">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap items-center justify-center gap-8 md:gap-16">
          <div className="text-white font-semibold text-lg hidden md:block">
            Lo que nos distingue
          </div>
          {badges.map((badge, index) => {
            const Icon = iconMap[badge.icon];
            return (
              <div key={index} className="flex items-center gap-3 text-white">
                <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center">
                  <CheckCircle size={20} className="text-cyan-300" />
                </div>
                <span className="font-medium">{badge.title}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Badges;
